import './App.css';
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { Toaster } from './components/ui/sonner';
import AuthModal from './components/AuthModal';
import MarketsPage from './pages/MarketsPage';
import PipelinePage from './pages/PipelinePage';
import PortfolioPage from './pages/PortfolioPage';
import AdminPage from './pages/AdminPage';

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<MarketsPage />} />
            <Route path="/pipeline" element={<PipelinePage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
          <Toaster position="bottom-right" theme="dark" />
          <AuthModal />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
